export default "__VITE_ASSET__d0bb6b17__"